export default function InputError({ children }) {
	return <p className="text-sm mt-1.5 text-red-500">{children}</p>;
}
